import Vue from 'vue'

export const serviceProviderHeaders = [
  {
    text: Vue.i18n.translate('forms.completeName'),
    value: 'name',
  },
  {
    text: Vue.i18n.translate('forms.document'),
    value: 'document',
    width: 200,
  },
  {
    value: 'actions',
    width: 100,
    align: 'right',
  },
]

export const serviceProviderCustomerHeaders = [
  {
    text: Vue.i18n.translate('forms.completeName'),
    value: 'name',
  },
  {
    text: Vue.i18n.translate('forms.document'),
    value: 'document',
    width: 200,
  },
  {
    value: 'actions',
    width: 100,
    align: 'right',
  },
]

export const serviceProviderUserHeaders = [
  {
    text: Vue.i18n.translate('forms.completeName'),
    value: 'name',
  },

  {
    text: Vue.i18n.translate('defaultServiceValues.label.status'),
    value: 'active',
    width: 100,
    align: 'center',
  },
  {
    value: 'actions',
    width: 100,
    align: 'right',
  },
]
